<template>
    <div>
      <!-- Button to open modal -->
      <button @click="openModal" type="button" class="btn btn-sm btn-outline-success me-2">
        <i class="fa-brands fa-whatsapp"></i>
        WhatsApp</button>
    
      <!-- Modal Overlay (using Bootstrap classes) -->
      <div v-if="isModalVisible" class="modal fade show" tabindex="-1" role="dialog" aria-labelledby="whatsappModalLabel" aria-hidden="true" style="display: block;">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="whatsappModalLabel">Send WhatsApp Message</h5>
              <button type="button" class="close" @click="closeModal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form @submit.prevent="sendMessage">
                <div class="form-group">
                  <label for="phoneNumbers">Recipient's Phone Numbers (comma separated)</label>
                  <input type="text" id="phoneNumbers" v-model="phoneNumbers" class="form-control" placeholder="Enter phone numbers" required>
                </div>
                <div class="form-group">
                  <label for="message">Message</label>
                  <textarea id="message" v-model="message" class="form-control" placeholder="Enter your message" required></textarea>
                </div>
                <button type="submit" class="btn btn-success">Send Message</button>
              </form>
            </div>
          </div>
        </div>
      </div>
  
      <!-- Overlay to close modal when clicked outside -->
      <div v-if="isModalVisible" class="modal-backdrop fade show" @click="closeModal"></div>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        isModalVisible: false,  // Controls the visibility of the modal
        phoneNumbers: '',       // User input for phone numbers (comma-separated)
        message: '',            // User input for the message content
      };
    },
    methods: {
      openModal() {
        this.isModalVisible = true;  // Set to true to show the modal
      },
      closeModal() {
        this.isModalVisible = false;  // Close the modal
      },
      sendMessage() {
        // Split the phone numbers by comma and trim spaces
        const numbersArray = this.phoneNumbers.split(',').map(number => number.trim());
  
        // Loop through each phone number and send the message
        numbersArray.forEach((number) => {
          const encodedMessage = encodeURIComponent(this.message);
          const url = `https://wa.me/${number}?text=${encodedMessage}`;
  
          // Open the WhatsApp link in a new tab for each phone number
          window.open(url, '_blank');
        });
  
        // Close the modal after sending the message
        this.closeModal();
      }
    }
  };
  </script>
  
  <style scoped>

  /* Modal Styles */
  .modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
  }
  
  .modal-dialog {
    max-width: 500px;
    margin: 30px auto;
  }
  
  /* Custom Input and Button styles */
  .form-control {
    margin-bottom: 15px;
  }
  
  textarea.form-control {
    height: 120px;
  }
  </style>
  